export function extractYear(name: string | undefined | null): number | null {
  if (!name) return null;
  const match = name.match(/\d{4}(?=[^0-9]*$)/);
  return match ? parseInt(match[0], 10) : null;
}
